import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronRightMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronRightMedium"><Path d="M16.8105 12L9.5 19.3105L8.43945 18.25L14.6895 12L8.43945 5.75L9.5 4.68945L16.8105 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronRightMedium;
